import React from "react";
import { useLocale } from "@insightfulscience/smart-react/i18";
import { string } from "prop-types";
import Spinner from "@insightfulscience/atomic-react/Spinner";
import SmartForm from "@insightfulscience/smart-react/SmartForm";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import Button from "@insightfulscience/atomic-react/Button";
import Block from "@insightfulscience/atomic-react/Block";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import Html from "@insightfulscience/smart-react/Html";
import {
	CastleNotice,
	GoogleRecaptchaNotice,
	useFormActionWithAnyCaptcha,
} from "@insightfulscience/smart-react/anyCaptcha";

import routes from "../routes";
import { requestFreeTrial } from "./action";
import { initialState, validateForm } from "./form";
import FlashErrorMessage from "../utils/FlashErrorMessage";
import { publicConfig } from "../config";

const FreeTrialForm = ({ trialTokenExpired }) => {
	const [t] = useLocale("free-trial");

	const [action, { isLoading, error, reset, type }] = useFormActionWithAnyCaptcha(
		requestFreeTrial,
		{
			endOn: "then",
			googleRecaptchaSiteKey: publicConfig.GOOGLE_RECAPTCHA_SITE_KEY,
			castlePublicKey: publicConfig.CASTLE_PUBLIC_KEY,
			action: "requestTrial",
		},
	);

	return (
		<>
			<Row utility={{ justify: "center" }}>
				{isLoading && <Spinner />}
				{trialTokenExpired && <FlashErrorMessage text={t("errors.EXPIRED_TOKEN")} />}
				<Col>
					<SmartForm textRender={t} {...{ initialState, validateForm, action }} onTouched={reset}>
						<Block sx={{ textAlign: "left" }}>
							<SmartForm.Field
								label="EMAIL"
								name="email"
								type="email"
								disabled={isLoading}
								error={error}
								fieldClassName="mb-6"
								required
								data-qa-selector="free-trial-email-input"
							/>
						</Block>
						<Row>
							<Col spacing={{ mt: 2, mb: 6 }}>
								<Block sx={{ textAlign: "center" }}>
									<Button
										type="submit"
										disabled={isLoading}
										isBlock
										data-qa-selector="free-trial-submit-button"
									>
										{t("SUBMIT")}
									</Button>
								</Block>
							</Col>
						</Row>
					</SmartForm>
				</Col>
			</Row>
			<Paragraph sx={{ fontSize: "xs", textAlign: "center" }}>
				<Html Tag="span">
					{t("AGREEMENT", {
						tosLink: routes.external.termsOfService,
						ppLink: routes.external.privacyPolicy,
					})}
				</Html>
			</Paragraph>
			{!!type && (
				<Block sx={{ textAlign: "center" }}>
					{type === "google-recaptcha" && <GoogleRecaptchaNotice />}
					{type === "castle" && <CastleNotice />}
				</Block>
			)}
		</>
	);
};

FreeTrialForm.propTypes = {
	trialTokenExpired: string,
};

export default FreeTrialForm;
